// app/javascript/controllers/flatpickr_controller.js
import Flatpickr from "stimulus-flatpickr"

// Import a theme (optional)
import "flatpickr/dist/themes/light.css"

// Import a language (optional)
import { default as en } from "flatpickr/dist/l10n/default.js"

export default class extends Flatpickr {
  connect() {
    // Define config in connect() to ensure it's passed correctly
    this.config = {
      locale: en,
      enableTime: true,
      time_24hr: false,
      minuteIncrement: 5,
      altInput: true,
      altFormat: "F j, Y h:i K",
      dateFormat: "Y-m-d H:i:S",
      minDate: "today",
      maxDate: new Date().fp_incr(365),
      onDayCreate: (dObj, dStr, fp, dayElem) => {
        const eventDates = JSON.parse(this.element.dataset.flatpickrEventDates || "[]")
        const eventBusyDates = JSON.parse(this.element.dataset.flatpickrEventBusyDates || "[]")
        // Use flatpickr's parseDate to format the date correctly
        const dayDateStr = fp.formatDate(dayElem.dateObj, "Y-m-d")

        if (eventDates.includes(dayDateStr)) {
          dayElem.innerHTML += '<span class="event"></span>'
        }

        if (eventBusyDates.includes(dayDateStr)) {
          dayElem.innerHTML += '<span class="event busy"></span>'
        }
      }
    };

    // This is crucial to initialize the Flatpickr instance
    super.connect()
  }

  change(selectedDates, dateStr, instance) {
    console.log("Selected date:", dateStr)
  }
}
